<div class="slider-container">
  <div id="carouselExampleCaptions" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <div style="background-color: #000000;height: 50px;"></div>
        <div class="carousel-caption d-md-block mb-3">
          <img src="assets/images/otr-leasing-logo.png" class="slider-otr-leasing-img d-block w-100" alt="...">

          <h1 class="mb-3">Your Truck is Waiting for You</h1>
          <h6 class="orange">We are not a carrier. We lease Class 8 semi-trucks to owner-operators and small fleet owners.</h6>

        </div>
      </div>

    </div>

  </div>
</div>
